import React, { useState } from 'react'
import { Button, Modal, notification, AutoComplete, Input } from "antd"

function SewingRepairModal(props) {
    const [loading, setLoading] = useState(false)
    const [repairType, setRepairType] = useState('')
    const { isOpen, onClose, inputValue, itemId, reset, title, titleBtn, options = [], api } = props

    const handleChangeError = (value) => {
        setRepairType(value)
    }

    const onCloseModal = () => {
        setRepairType('')
        onClose()
    }

    const onSewingRepair = async () => {
        setLoading(true)
        try {
            const payload = {
                type: repairType,
            }
            const { data: res } = await api(itemId, payload)
            const { success, error: message } = res
            if (success) {
                notification.success({
                    message: `${titleBtn} thành công`,
                    description: `Bạn đã ${titleBtn.toLowerCase()} cho item ${inputValue} thành công`,
                })
                onCloseModal()
                reset()
            } else {
                notification.error({
                    message: `${titleBtn} item ${inputValue}  không thành công`,
                    description: message,
                })
            }
        } catch (error) {
            notification.error({
                message: `${titleBtn} không thành công`,
                description: error,
            })
        } finally{
            setLoading(false)
        }
    }

    const { TextArea } = Input;

    return (
        <div className='SewingRepairModal'>
            <Modal
                visible={isOpen}
                title={(
                    <div className='d-flex justify-content-between'>
                        <div>{title}</div>
                        <div className='mx-3'>{inputValue}</div>
                    </div>
                )}
                onOk={onSewingRepair}
                onCancel={onCloseModal}
                className='MarkItemErrorModal MarkItemModalQCComplete'
                footer={[
                    <Button key="back" onClick={onCloseModal}>
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="danger"
                        loading={loading}
                        style={{ background: '#ffc107', borderColor: '#ffc107' }}
                        onClick={onSewingRepair}
                    >
                        {titleBtn}
                    </Button>
                ]}
            >
                <div className="Content">
                    <div className="ErrorStyle">
                        <label htmlFor="error_type" className="Error">Lỗi:</label>
                        <AutoComplete
                            options={options}
                            dataSource={options}
                            filterOption={(inputValue, option) =>
                                option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onChange={handleChangeError}
                            allowClear
                            className='w-100'
                        >
                            <TextArea
                                placeholder="Nhập lỗi"
                                style={{ height: 100 }}
                            />
                        </AutoComplete>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default SewingRepairModal